import { DownOutlined } from '@ant-design/icons';
import { Alert, Button, Card, Col, Dropdown, Form, Input, Modal, notification, Row, Space, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../../utils/axios';
import { useLoader } from '../../../../context/LoaderContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { downloadFile } from '../../../../utils';
const ListeApprenants = () => {
      const [data, setData] = useState([]);
      const params = useLocation();
      const idDemande = params?.state?.idSession
        const [modalVisible, setModalVisible] = useState(false);
        const [demandeurs, setDemandeurs] = useState([]);
        const [refresh, setRefresh] = useState(false);
        const [selectedSession, setSelectedSession] = useState(null);
        const [selectedRowKeys, setSelectedRowKeys] = useState([]);
          const navigate = useNavigate();
  const { t } = useTranslation();
    const { setIsLoading } = useLoader();
  const consulterPreInscrit = (record,type) => {
    navigate("/pre-inscrit/" + record?.id_formation, {
      state: {
        type: type,
        id_apprenant: record.id,
      },
    });
  };
      const columns =   [

    {
      title: t("Nom"),
      key: "Nom",
      render: (_, record) =>
        localStorage.getItem("language") === "ar" && record?.name_ar
          ? record?.name_ar
          : record?.name,
    },
    {
      title: t("Prénom"),
      key: "Prénom",
      render: (_, record) =>
        localStorage.getItem("language") === "ar" && record?.surname
          ? record?.surname
          : record?.surname_ar,
    },
    {
      title: t("Nationnalité"),
      key: "Nationnalité",
      render: (_, record) =>
        record?.nationality,
    },
    {
      title: t("Identifiant"),
      key: "Identifiant",
      render: (_, record) => record?.cin ? record?.cin  :  record?.passport,
    },
      {
      title: t("Statut"),
      key: "Statut",
        render: (_, record) => {
        return (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "5px",
              fontSize: "12px",
              backgroundColor:
                record?.statut_couleur_background,
              color:
              record?.etat_color,
            }}
          >
            {t(record?.statut_apprenant)}
          </span>
        );
      },
    },
 {
          title: t("Actions"),
          key: "Actions",
          render: (_, record) => (
            <Space>
              <Dropdown
                menu={{
                  items: [
                    {
                      label: (
                        <Button
                          size="small"
                          block
                           onClick={() => consulterPreInscrit(record,"consulter")}
                        >
                          {t("Consulter")}
                        </Button>
                      ),
                    },
                    {
                      label: (
                        <Button
                          size="small"
                          block
                       
                        >
                          {t("Abandonner")}
                        </Button>
                      ),
                    },

                            {
                                      label: (
                                        <Button
                                          size="small"
                                          block
                                                  onClick={() => {
                                                                 setIsLoading(true)
                                                              const filesToDownload = [
          { content: record?.attestation_de_presence_base64, name: "attestation_présence" },
          { content: record?.attestation_inscription_base64, name: "attestation_inscription" },
        ];

        filesToDownload.forEach(file => {
          if (file.content) {
            downloadFile(file.content, file.name);
          }
        });

        setIsLoading(false);
                                                               }}
                                        >
                                          {t("Télécharger les documents")}
                                        </Button>
                                      ),
                                    },
                  
                  ],
                }}
                trigger={["click"]}
              >
                <span style={{ cursor: "pointer" }}>
                  <Space>
                    {t("Liste")}
                    <DownOutlined />
                  </Space>
                </span>
              </Dropdown>
            </Space>
          ),
        },
  ]

  
      useEffect(() => {
        setIsLoading(true)
        async function fetchData() {
          axiosInstance
            .get(`${import.meta.env.VITE_APP_GEOPROD_API}/list_apprenant?id_affaire=${idDemande}`, {
              headers: {
                Idsession: JSON.parse(sessionStorage.getItem("-x-token-user"))
                  ?.Acces_Token,
              },
            })
            .then((res) => {
                setData(res?.data?.message?.Data);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });
        }
    
        fetchData();
      }, [refresh]);

      const fetchDemandeurs = async () => {
        try {
          setIsLoading(true)
          const res = await axiosInstance.get(
            `${
              import.meta.env.VITE_APP_GEOPROD_API
            }/list_apprenant?id_formation=${parseInt(params?.state?.id_session_formation)}`,
            {
              headers: {
                Idsession: JSON.parse(sessionStorage.getItem("-x-token-user"))
                  ?.Acces_Token,
              },
            }
          );
          setIsLoading(false)
          return res?.data?.message?.Data || [];
        } catch (error) {
          setIsLoading(false)
          notification.error({
            message: "Erreur",
            description: "Impossible de récupérer les demandeurs.",
          });
          return [];
        }
      };
      const addApprenantsToSession = async ( ids) => {
        try {
          await axiosInstance.post(
            `${import.meta.env.VITE_APP_GEOPROD_API}/add_apprenant_to_session`,
            {
              list_apprenants: ids,
              id_session: idDemande,
            },
            {
              headers: {
                Idsession: JSON.parse(sessionStorage.getItem("-x-token-user"))
                  ?.Acces_Token,
              },
            }

          );
          setRefresh(!refresh)

          notification.success({
            message: "Succès",
            description: "Apprenants ajoutés avec succès.",
          });
        } catch (error) {
          console.log("erro",error)
          notification.error({
            message: "Erreur",
            description: t(error?.data?.message),
          });
        }
      };
      const handleOpenModal = async (session) => {
        const demandeursData = await fetchDemandeurs();
        setSelectedSession(session);
        setDemandeurs(demandeursData);
        setSelectedRowKeys([]);
        setModalVisible(true);
      };
      const handleAddParticipant = async () => {
        if(data?.length === 20 )
        {
        notification.error({
           message: t("Nombre maximal atteint"),
           description: t("Vous ne pouvez pas ajouter d’autres apprenants à cette session de formation, car le nombre maximal autorisé dans le cadre de l’homologation a déjà été atteint."),
          duration: 0,
        });
        }
else
        { 
          const ids = selectedRowKeys.map((id) => {
          const participant = demandeurs.find((p) => p.id === id);
          return participant?.id;
        });
        await addApprenantsToSession( ids);
        setModalVisible(false);
        setSelectedRowKeys([]);
        }

 
      };
  return (
    <div>
      <Alert type="info"   
    style={{ marginBlock: "20px" }}
  message="Configuration"
 description={`Liste des apprenants`}  showIcon />
      <Card title="Liste des apprenants" bordered={false}  extra={
            <Button type="primary"  onClick={() => handleOpenModal()}>
              {t("Ajouter des apprenants")}
            </Button>
          } >
      <Table
            locale={{ emptyText: t("Aucune donnée") }}
            // loading={loading}
            columns={columns}
            dataSource={data}
            className="ant-border-space"
            style={{ overflowX: "auto" }}
            pagination={true}
          />
       
      </Card>
        <Modal
              title="Ajouter des apprenants"
              open={modalVisible}
              okText="Ajouter"
              cancelText="Annuler"
              onCancel={() => setModalVisible(false)}
              onOk={handleAddParticipant}
              okButtonProps={{ disabled: selectedRowKeys.length === 0 }}
            >
              <Table
                rowSelection={{
                  selectedRowKeys,
                  onChange: (keys) => setSelectedRowKeys(keys),
                }}
                columns={
                    [

    {
      title: t("Nom"),
      key: "Nom",
      render: (_, record) =>
        localStorage.getItem("language") === "ar" && record?.name_ar
          ? record?.name_ar
          : record?.name,
    },
    {
      title: t("Prénom"),
      key: "Prénom",
      render: (_, record) =>
        localStorage.getItem("language") === "ar" && record?.surname
          ? record?.surname
          : record?.surname_ar,
    },
    {
      title: t("Nationnalité"),
      key: "Nationnalité",
      render: (_, record) =>
        record?.nationality,
    },
    {
      title: t("Identifiant"),
      key: "Identifiant",
      render: (_, record) => record?.cin ? record?.cin  :  record?.passport,
    },
    {
      title: t("Statut"),
      key: "Statut",
        render: (_, record) => {
        return (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "5px",
              fontSize: "12px",
              backgroundColor:
                record?.statut_couleur_background,
              color:
              record?.etat_color,
            }}
          >
            {t(record?.statut_apprenant)}
          </span>
        );
      },
    },
  ]
                  
                 }
                dataSource={demandeurs}
                rowKey="id"
                size="small"
              />
            </Modal>

    </div>
  )
}

export default ListeApprenants